import { createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, vShow as _vShow, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/search_icon.png'


const _hoisted_1 = { class: "pantry-add-page" }
const _hoisted_2 = { class: "pantry-add-page-area" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "pantry-add-page-summary" }, "追加したい食材を選択してください。", -1)
const _hoisted_4 = { class: "pantry-add-page-search-input-area" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "pantry-add-page-search-input-icon" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "commonSearchIcon pantry-add-page-search-input-icon-image",
    src: _imports_0
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "pantry-add-page-input-view-button-text" }, "検索", -1)
const _hoisted_7 = { class: "pantry-add-page-category-area" }
const _hoisted_8 = { class: "pantry-add-page-ingredeint-area" }
const _hoisted_9 = { class: "pantry-add-page-ingredeint-view" }
const _hoisted_10 = { class: "pantry-add-page-ingredeint-view" }
const _hoisted_11 = { class: "pantry-add-page-ingredeint-view" }
const _hoisted_12 = { class: "pantry-add-page-ingredeint-view" }
const _hoisted_13 = { class: "pantry-add-page-ingredeint-view" }
const _hoisted_14 = { class: "pantry-add-page-bottom-bar-area" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "pantry-add-page-button-bottom-skip" }, [
  /*#__PURE__*/_createVNode("div", { class: "pantry-add-page-button-text" }, "スキップ")
], -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "pantry-add-page-button-bottom-next" }, [
  /*#__PURE__*/_createVNode("div", { class: "pantry-add-page-button-text" }, "次へ")
], -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "pantry-add-page-header" }, [
  /*#__PURE__*/_createVNode("div", { class: "pantry-add-page-title-text" }, "在庫メンテナンス")
], -1)
const _hoisted_18 = { class: "pantry-add-page-camera-check-view-area" }
const _hoisted_19 = { class: "pantry-add-page-food-search-view-area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectCategory = _resolveComponent("SelectCategory")
  const _component_PantryIngredientCameraListView = _resolveComponent("PantryIngredientCameraListView")
  const _component_PantryIngredientView = _resolveComponent("PantryIngredientView")
  const _component_PantryIngredientFoodListView = _resolveComponent("PantryIngredientFoodListView")
  const _component_PantryCameraCheckMainView = _resolveComponent("PantryCameraCheckMainView")
  const _component_PantryFoodSearchView = _resolveComponent("PantryFoodSearchView")
  const _component_CommonDesignDialog = _resolveComponent("CommonDesignDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createVNode("input", {
          ref: "textInput",
          class: "commonSearchText",
          type: "text",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.keywordComputed = $event)),
          placeholder: "テキストを入力",
          enterkeyhint: "done",
          onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.handleEnter()), ["enter"]))
        }, null, 544), [
          [_vModelText, _ctx.keywordComputed]
        ]),
        _createVNode("div", {
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClickSearch(...args))),
          class: "pantry-add-page-input-view-button"
        }, [
          _hoisted_6
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_SelectCategory, {
          categoryNameList: _ctx.categoryNameList,
          selectIndex: _ctx.selectNo,
          key: _ctx.updateCategoryKey,
          onOnSelect: _ctx.selectCategory
        }, null, 8, ["categoryNameList", "selectIndex", "onOnSelect"]),
        _withDirectives(_createVNode("div", _hoisted_8, [
          _withDirectives(_createVNode("div", _hoisted_9, [
            _createVNode(_component_PantryIngredientCameraListView, {
              key: _ctx.updateCameraListDisplayKey,
              id: _ctx.PANTRY_ADD_CATEGORY_NAME_TYPE.CAMERA,
              recoginitionCheckList: _ctx.recoginitionCheckList,
              recoginitionList: _ctx.recoginitionList,
              onClickButtonRecoginitionCheckTitle: _ctx.clickRecoginitionCheckTitle,
              onClickButtonRecoginitionTitle: _ctx.clickRecoginitionTitle,
              onClickButtonRecoginitionCheckItem: _ctx.clickRecoginitionCheckItem,
              onOnSelect: _ctx.onSelectIngredient
            }, null, 8, ["id", "recoginitionCheckList", "recoginitionList", "onClickButtonRecoginitionCheckTitle", "onClickButtonRecoginitionTitle", "onClickButtonRecoginitionCheckItem", "onOnSelect"])
          ], 512), [
            [_vShow, _ctx.isSelect(_ctx.PANTRY_ADD_CATEGORY_NAME_TYPE.CAMERA)]
          ]),
          _withDirectives(_createVNode("div", _hoisted_10, [
            _createVNode(_component_PantryIngredientView, {
              key: _ctx.updateListCheck,
              "v-bind": _ctx.purChasedList,
              id: _ctx.PANTRY_ADD_CATEGORY_NAME_TYPE.PURCHASED,
              categoryTitle: _ctx.PANTRY_ADD_CATEGORY_NAME_TYPE.PURCHASED,
              ingredientList: _ctx.purChasedList,
              onOnSelect: _ctx.onSelectIngredient
            }, null, 8, ["v-bind", "id", "categoryTitle", "ingredientList", "onOnSelect"])
          ], 512), [
            [_vShow, _ctx.isSelect(_ctx.PANTRY_ADD_CATEGORY_NAME_TYPE.PURCHASED)]
          ]),
          _withDirectives(_createVNode("div", _hoisted_11, [
            _createVNode(_component_PantryIngredientView, {
              key: _ctx.updateListCheck,
              "v-bind": _ctx.favoriteList,
              id: _ctx.PANTRY_ADD_CATEGORY_NAME_TYPE.FAVORITE,
              categoryTitle: _ctx.PANTRY_ADD_CATEGORY_NAME_TYPE.FAVORITE,
              ingredientList: _ctx.favoriteList,
              onOnSelect: _ctx.onSelectIngredient
            }, null, 8, ["v-bind", "id", "categoryTitle", "ingredientList", "onOnSelect"])
          ], 512), [
            [_vShow, _ctx.isSelect(_ctx.PANTRY_ADD_CATEGORY_NAME_TYPE.FAVORITE)]
          ]),
          _withDirectives(_createVNode("div", _hoisted_12, [
            _createVNode(_component_PantryIngredientView, {
              key: _ctx.updateListCheck,
              "v-bind": _ctx.rankingList,
              id: _ctx.PANTRY_ADD_CATEGORY_NAME_TYPE.RANKING,
              categoryTitle: _ctx.PANTRY_ADD_CATEGORY_NAME_TYPE.RANKING,
              ingredientList: _ctx.rankingList,
              onOnSelect: _ctx.onSelectIngredient
            }, null, 8, ["v-bind", "id", "categoryTitle", "ingredientList", "onOnSelect"])
          ], 512), [
            [_vShow, _ctx.isSelect(_ctx.PANTRY_ADD_CATEGORY_NAME_TYPE.RANKING)]
          ]),
          _createVNode("div", _hoisted_13, [
            _createVNode(_component_PantryIngredientFoodListView, {
              key: _ctx.updateDisplayKey,
              selectName: _ctx.selectCategoryName,
              foodList: _ctx.foodList,
              update: _ctx.updateDisplayKey,
              onOnSelect: _ctx.onSelectIngredient
            }, null, 8, ["selectName", "foodList", "update", "onOnSelect"])
          ])
        ], 512), [
          [_vShow, _ctx.isShowList()]
        ])
      ]),
      _createVNode("div", _hoisted_14, [
        (_ctx.isSelectEmpty())
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              class: "pantry-add-page-button",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onClickBottom(...args)))
            }, [
              _hoisted_15
            ]))
          : (_openBlock(), _createBlock("div", {
              key: 1,
              class: "pantry-add-page-button",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onClickBottom(...args)))
            }, [
              _hoisted_16
            ]))
      ])
    ]),
    _hoisted_17,
    _withDirectives(_createVNode("div", _hoisted_18, [
      _createVNode(_component_PantryCameraCheckMainView, {
        key: _ctx.updateCheckDisplayKey,
        update: _ctx.updateCheckDisplayKey,
        foodList: _ctx.checkCameraFoodList,
        selectPosition: _ctx.checkCamereSelectPosition,
        isFoodTimerExec: _ctx.isFoodTimerExec,
        onClickFood: _ctx.onClickCheckCameraFood,
        onClickInput: _ctx.onClickCheckCameraInput,
        onClickBack: _ctx.onClickCheckCameraBack,
        onClickSkip: _ctx.onClickCheckCameraSkip,
        onClickClose: _ctx.onClickCheckCameraClose,
        onSelectImage: _ctx.selectCheckCameraImage,
        onStatus: _ctx.onStatusCameraCheck
      }, null, 8, ["update", "foodList", "selectPosition", "isFoodTimerExec", "onClickFood", "onClickInput", "onClickBack", "onClickSkip", "onClickClose", "onSelectImage", "onStatus"])
    ], 512), [
      [_vShow, _ctx.isShowCheckCamera]
    ]),
    _withDirectives(_createVNode("div", _hoisted_19, [
      _createVNode(_component_PantryFoodSearchView, {
        key: _ctx.updateKeywordKey,
        list: _ctx.recipeFoodList,
        keyword: _ctx.inputKeyword,
        onClickClose: _ctx.onFoodSearchClose,
        onClickSearch: _ctx.onFoodSearch,
        onSelectFood: _ctx.onSelectFood
      }, null, 8, ["list", "keyword", "onClickClose", "onClickSearch", "onSelectFood"])
    ], 512), [
      [_vShow, _ctx.isShowFoodSearch]
    ]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: _ctx.isShowComplite,
      dialogType: 16,
      title: 'パントリーが更新されました',
      message: 
        'いつもチェックありがとうございます。この内容をもとに新しいおすすめを提案します。'
      ,
      negativeLabel: '完了する',
      onNegativeClick: _ctx.onClickCompliteButton
    }, null, 8, ["isShowDialog", "onNegativeClick"]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: _ctx.isShowAddComplite,
      dialogType: 12,
      title: '登録完了しました',
      negativeLabel: '閉じる',
      onNegativeClick: _ctx.onClickAddCompilteNegative
    }, null, 8, ["isShowDialog", "onNegativeClick"]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: _ctx.isShowCheckError,
      dialogType: 9,
      title: '修正対象がありません',
      message: '未チェック食材を対象に一括確認ができます',
      negativeLabel: 'OK',
      onNegativeClick: _ctx.onClickCheckeErrorNegative
    }, null, 8, ["isShowDialog", "onNegativeClick"]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: !!_ctx.handleApiError,
      dialogType: 9,
      title: _ctx.getApiErrorTitle,
      message: _ctx.getApiErrorMessage,
      negativeLabel: _ctx.ERROR_BUTTON_LABEL,
      onNegativeClick: _ctx.closeError
    }, null, 8, ["isShowDialog", "title", "message", "negativeLabel", "onNegativeClick"])
  ]))
}